var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.68 1.084a1.03 1.03 0 0 0-1.415 0L4.843 8.236l-3.118-3.01A1.02 1.02 0 0 0 1 4.95a1.05 1.05 0 0 0-.714.298.947.947 0 0 0 .025 1.385l3.825 3.683a1 1 0 0 0 .707.283 1.03 1.03 0 0 0 .708-.284l8.128-7.823a1 1 0 0 0 .237-.32.93.93 0 0 0-.237-1.09"
  })));
};
export default SvgTick;